import React, {useState, useEffect, useMemo} from 'react';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

import {ConfirmDialog, hooks, PrettyJson, SelectPlus, toast} from 'lib.front';
import {makeStyles} from 'tss-react/mui';
import {useDispatch} from 'react-redux';
import {loadingModal} from 'src/redux-app';
import {Aplicacion} from '../../bussines/entities/Aplicacion';
import useDatabaseMetadata from '../hooks/useDatabaseMetadata';
import DatabaseMetadataTable from '../components/DatabaseMetadataTable';
import {DeleteDatabasesUseCase} from '../../bussines/useCases/DeleteDatabasesUseCase';
import {GestionarAppDbsRepositoryImpl} from '../../data/repository/GestionarAppDbsRepositoryImpl';
import {useApolloClient} from '@apollo/client';
import {GestionarAppDtSourceImplGql} from '../../data/datasources/GestionarAppDtSourceImplGql';
import {DatabaseMetadata} from '../../bussines/entities/DatabaseMetadata';

const useStyles = makeStyles()(theme => ({
   container: {
      marginTop: theme.spacing(2)
   },
   input: {
      maxWidth: '500px',
   }
}));
interface SelectPlusValue<T> {
   value: string;
   label: string;
   dataItem: T | null;
}
const TipoCambio = () => {
   const {classes, cx} = useStyles();
   const dispatch = useDispatch();
   const apolloClient = useApolloClient();
   const {setIsloadingModal, openModalComponent} = hooks.useOpenModalStore(dispatch);
   const [isOpenConfirmDialog, setIsOpenConfirmDialog] = useState(false);
   function openConfirmarDialog() {
      setIsOpenConfirmDialog(true);
   }
   function closeConfirmarDialog() {
      setIsOpenConfirmDialog(false);
   }
   //Filtros
   const [multiDbApp, setMultiDbApp] = useState<SelectPlusValue<Aplicacion> | null>(null);
   const handleMultiDbAppChange = (elegido: SelectPlusValue<Aplicacion> | null) => {
      setMultiDbApp(elegido);
   };

   const [nroDias, setNroDias] = useState<number>(30);
   const handleOnNroDiasChange = (newNroDias: number) => {
      setNroDias(newNroDias);
   };

   const {databasesMetadata, estadoMsg, reloadDatabaseMetadata} = useDatabaseMetadata(
      multiDbApp?.dataItem || null,
      nroDias
   );

   const [selected, setSelected] = useState<string[]>([]);

   const deleteDatabases = useMemo(() => {
      const dtSource = new GestionarAppDtSourceImplGql(apolloClient);
      const repo = new GestionarAppDbsRepositoryImpl({dataSourceGql: dtSource});
      const deleteDatabase = new DeleteDatabasesUseCase(repo);
      return deleteDatabase;
   }, []);

   async function handleOnConfirmClick() {
      closeConfirmarDialog();
      if (multiDbApp && selected.length > 0 && databasesMetadata.length > 0) {
         setIsloadingModal(true);
         const list: DatabaseMetadata[] = selected.map(curr => {
            const found = databasesMetadata.find(currMeta => currMeta.id === curr);
            return found!;
         });
         const result = await deleteDatabases.call({appId: multiDbApp.value, list});
         setIsloadingModal(false);
         if (result.isSuccess()) {
            toast.showSucces('Bases de datos eliminadas satisfactoriamente');
            openModalComponent(PrettyJson, {
               ombreCampoId: 'resultado',
               objeto: {resultado: result.data!}
            });
            setSelected([]);
            reloadDatabaseMetadata();
         } else {
            openModalComponent(PrettyJson, {
               ombreCampoId: 'error',
               objeto: {error: result.error!}
            });
         }
      }
   }

   return (
      <Container className={cx('containerbox', classes.container)} maxWidth="md">
         <Grid container spacing={1}>
            <Grid id="grid-header" container item xs={12}>
               <Grid id="grid-titulo" item xs={9}>
                  <Typography variant="h4" gutterBottom align="center">
                     Gestionar Bases de Datos de Aplicaciones
                  </Typography>
               </Grid>
            </Grid>
            <Grid id="grid-tabla" container item xs={12}>
               <DatabaseMetadataTable
                  data={databasesMetadata}
                  estadoData={estadoMsg}
                  //
                  appSelected={multiDbApp}
                  onAppSelectedChange={handleMultiDbAppChange}
                  //
                  selected={selected}
                  onSelectedChange={newSelected => {
                     setSelected(newSelected);
                  }}
                  //
                  onDeleteClick={openConfirmarDialog}
                  //
                  nroDias={nroDias}
                  onNroDiasChange={handleOnNroDiasChange}
               />
            </Grid>
         </Grid>
         {
            //@ts-ignore
            <ConfirmDialog
               variant="warning"
               open={isOpenConfirmDialog}
               setOpen={setIsOpenConfirmDialog}
               onConfirm={handleOnConfirmClick}
            >
               ¿Esta seguro que desea eliminar las bases de datos elegidas?
            </ConfirmDialog>
         }
      </Container>
   );
};

export default TipoCambio;
